// Card Sintesi Tecnica: potenze totali, rapporto DC/AC e totale listino
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Separator } from '../ui/separator';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { Sun, Zap, Battery, Gauge, Euro, Info } from 'lucide-react';
import { TechMetric } from './TechMetric';

export function SintesiTecnicaCard({ calculations, storageEnabled }) {
  return (
    <Card className="lg:col-span-7 bg-white border-zinc-200 rounded-2xl shadow-sm" data-testid="sintesi-tecnica-card">
      <CardHeader className="pb-4">
        <CardTitle className="text-lg font-bold text-zinc-900 flex items-center gap-2">
          <Gauge className="h-5 w-5 text-zinc-500" />
          Sintesi Tecnica Impianto
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <TechMetric
            label="Potenza Moduli"
            value={calculations.totalModuliPower}
            unit="kWp"
            icon={Sun}
            tooltip="Somma della potenza massima (Pmax) di tutti i moduli configurati"
          />
          <TechMetric
            label="Potenza Inverter"
            value={calculations.totalInverterPower}
            unit="kW"
            icon={Zap}
            tooltip="Somma della potenza nominale AC di tutti gli inverter configurati"
          />
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <Gauge className="h-4 w-4 text-zinc-400" />
              <span className="text-sm text-zinc-500 font-medium">Rapporto DC/AC</span>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Info className="h-3 w-3 text-zinc-300 cursor-help" />
                </TooltipTrigger>
                <TooltipContent className="bg-zinc-900 text-zinc-50 text-xs px-3 py-2 rounded-lg max-w-xs">
                  Il rapporto tra potenza DC dei moduli e potenza AC degli inverter. Valori ottimali: 0.8 - 1.3
                </TooltipContent>
              </Tooltip>
            </div>
            <div className="flex items-baseline gap-2">
              <span className={`font-mono text-2xl font-bold ${calculations.dcAcStatus.color}`}>
                {calculations.dcAcRatio || '-'}
              </span>
              <Badge
                variant="outline"
                className={`text-xs ${
                  calculations.dcAcStatus.status === 'ok' ? 'bg-emerald-50 text-emerald-700 border-emerald-200' :
                  calculations.dcAcStatus.status === 'warning' ? 'bg-amber-50 text-amber-700 border-amber-200' :
                  calculations.dcAcStatus.status === 'error' ? 'bg-rose-50 text-rose-700 border-rose-200' :
                  'bg-zinc-50 text-zinc-500'
                }`}
              >
                {calculations.dcAcStatus.message}
              </Badge>
            </div>
          </div>
          {storageEnabled && (
            <TechMetric
              label="Capacità Storage"
              value={calculations.totalStorageCapacity}
              unit="kWh"
              icon={Battery}
              tooltip="Capacità nominale totale dei sistemi di accumulo"
            />
          )}
        </div>

        {calculations.totalPrice > 0 && (
          <>
            <Separator className="my-6" />
            <div className="flex items-center justify-between">
              <span className="text-sm text-zinc-500 font-medium">Totale Listino Materiali</span>
              <span className="font-mono text-2xl font-bold text-zinc-900 flex items-center gap-1">
                <Euro className="h-5 w-5" />
                {calculations.totalPrice.toLocaleString('it-IT', { minimumFractionDigits: 2 })}
              </span>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
